module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="shared-set-container">\n    <div class="detail-header-region"></div>\n\n    <div class="objects-container list-layout-scroll-container">\n        <div class="list-header-region"></div>\n        <div class="container container-with-dnd objects-list-region"></div>\n    </div>\n</div>';
}
return __p;
};